import React, { useEffect } from 'react'
import { Image, StyleSheet } from 'react-native'

import { translate } from '../../i18n'
import { useStore } from '../../models'
import { DS } from '../../design-system'
import { NotificationScreenLayout } from '../../components/Notifications/NotificationScreenLayout'
import EmailUpdateImage from '../../../assets/Onboarding/EmailUpdate.png'
import { useThrottledCallback } from 'use-debounce'
import { useRouter } from 'expo-router'
import { events } from '@/models/analytics/analytics-events'

export const EmailUpdatesScreen = () => {
  const router = useRouter()
  const store = useStore()

  const userId = store.session.user?._id.toString()

  const subscribeNewsLetter = useThrottledCallback(async (optIn: boolean) => {
    await store.session.subscribeNewsLetter({ optIn })
    store.session.setIsSubscribedToNewsletter(optIn)

    const event = optIn
      ? events.emailUpdates.onboarding_email_optin_selected
      : events.emailUpdates.onboarding_email_skip_selected
    store.analytics.setEvent(event, {
      userId,
      screen_name: 'onboarding_email'
    })

    router.navigate('/onboarding/start-playing')
  }, 1000)

  useEffect(() => {
    store.analytics.setEvent(events.emailUpdates.onboarding_email_screen_viewed, {
      userId,
      screen_name: 'onboarding_email'
    })
  }, [store.analytics.setEvent, userId])

  return (
    <NotificationScreenLayout
      firstButtonLabel="Get updates"
      secondButtonLabel="Not right now"
      onFirstButtonPress={() => subscribeNewsLetter(true)}
      onSecondButtonPress={() => subscribeNewsLetter(false)}
    >
      <DS.Frame style={styles.centerFrame}>
        <Image source={EmailUpdateImage} style={styles.image} />
        <DS.Text variant="Heading 2/Medium" textAlign="center">
          {translate('newsLetter.heading')}
        </DS.Text>
      </DS.Frame>
    </NotificationScreenLayout>
  )
}

const styles = StyleSheet.create({
  centerFrame: {
    alignItems: 'center'
  },
  image: { width: 96, height: 96 }
})
